export default __webpack_public_path__ + "fca513cd8a12be65fe960aa4bde40270.png";